import Button from '../../../components/Button/Button';
import { textStyles } from '../../../constants/textStyles';

const ClientRegistrationApprove = ({ onSubmit }) => {
  return (
    <div>
      <h1
        style={{
          ...textStyles.formTitle,
          marginBottom: 20,
        }}
      >
        ÐÐ»Ð¸ÐµÐ½Ñ ÑÐºÐ°Ð·Ð°Ð», ÑÑÐ¾ Ð¼Ð°ÑÐ¸Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð° Ð½Ð° ÑÑÐµÑ
      </h1>

      <Button text={'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ'} fill onClick={onSubmit} />
    </div>
  );
};

export default ClientRegistrationApprove;
